import React from 'react';

const CLIENT_ID = 'ajelf9b8o183pqmhgnlv'; // замените позже
const REDIRECT_URI = window.location.origin + '/callback';

const Login = () => {
  const handleLogin = () => {
    // Формируем URL для редиректа на Яндекс OAuth
    const authUrl = `https://auth.yandex.cloud/oauth/authorize?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&scope=openid%20profile%20email`;
    window.location.href = authUrl;
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Вход в приложение</h1>
      <button onClick={handleLogin}>Войти через Яндекс</button>
    </div>
  );
};

export default Login;